const moduleShareMask = {
	namespaced: true,
	state: {
		MASK_ACTIVE: false,
		ID: '',
	},
	mutations: {
		SET_MASK_ACTIVE: (state, params) => {
			state.MASK_ACTIVE = params
		},
		SET_ID: (state, params) => {
			state.ID = params
		},
	},
	actions: {},
	getters: {},
}

export default moduleShareMask
